import { DiscountHistory, DiscountType } from 'types';

interface Props {
  historyEntry: DiscountHistory;
}

export function DiscountHistoryContent({ historyEntry }: Props) {
  const { entries } = historyEntry;

  const renderEntries = entries.map(
    ({ discountType, newDiscount, oldDiscount, customDiscount }) => {
      let contentTitle = 'Desconto personalizado';

      switch (discountType) {
        case DiscountType.TimelessSeason:
          contentTitle = 'Estações atemporais';
          break;

        case DiscountType.PastSeasons:
          contentTitle = 'Estações passadas';
          break;

        default:
          if (customDiscount) {
            const { collection } = customDiscount;

            contentTitle = collection;
          }
          break;
      }

      return (
        <div className="flex flex-col">
          <span className="text-font12 font-bold">{contentTitle}</span>

          <span className="text-font12">
            Desconto {oldDiscount}% para {newDiscount}%
          </span>
        </div>
      );
    }
  );

  return <div className="flex flex-col gap-2">{renderEntries}</div>;
}
